import SearchField from './searchField';

const PageToolbar = ({
  handleSearchField,
  setSearchTerm,
  setSearchQuery,
  searchText,
  searchTerm,
  children,
  title,
}: {
  handleSearchField?: any;
  setSearchTerm?: any;
  searchTerm?: any;
  searchText?: any;
  setSearchQuery?: any;
  children?: any;
  title?: any;
}) => {
  return (
    <div className='d-flex  mb-4 justify-content-between align-items-center'>
      <div className='d-flexformobile gap-4 align-items-center '>
        {title ? (
          <div className='d-flex gap-3 align-items-center '>
            <div className='row '>
              <div className='col-sm-12 my-auto'>
                <h1 className='rates__title'>{title}</h1>
              </div>
            </div>
          </div>
        ) : null}
        <div style={{ minWidth: '331px' }}>
          <div className='input-group '>
            <SearchField
              id={'search-field'}
              placeHolder={'Search here'}
              className={'form-control ubbe-input '}
              handleSearchField={handleSearchField}
              setSearchQuery={setSearchTerm}
              searchText={searchTerm}
            />
          </div>
        </div>
      </div>
      {children}
    </div>
  );
};

export default PageToolbar;
